import React from 'react';
import PropTypes from 'prop-types';
import PreferencesCommonStudySelector from './PreferencesCommonStudySelector';
import PreferencesCustomDropdown from './PreferencesCustomDropdown';
import PreferencesCommonSmartSearch from './PreferencesCommonSmartSearch';
import PreferencesCommonListMenu from './PreferencesCommonListMenu';
import PreferencesCustomRadioButtons from './PreferencesCustomRadioButtons';
import PreferencesCommonDataInput from './PreferencesCommonDataInput';
import PreferencesCustomCheckbox from './PreferencesCustomCheckbox';
import PreferencesCommonInlineEdit from './PreferencesCommonInlineEdit';
import PreferencesCommonDropdown from './PreferencesCommonDropdown';
import PreferencesCommonFilterSlider from './PreferencesCommonFilterSlider';
import PreferencesAutoUpdateCheckbox from './PreferencesAutoUpdateCheckbox';
import PreferencesCommonFilterSearch from './PreferencesCommonFilterSearch';
import ColorPickerInputBox from './ColorPickerInputBox';
import PreferencesCommonRangeFilter from './PreferencesCommonRangeFilter';
import PreferencesCommonProfileAttitudeList from './preferenceCommonProfileAttitudeList';
import PreferencesCommonStudyFamilySelector from './PreferencesCommonStudyFamilySelector';


const getMatchedInputComponent = (field, updatePreferences, handleWeightTypes,
  modifiedPreferences, userPreferences, setPreferenceWarning, autoUpdate, latestStudies,
  cancelAutoUpdateFlag, toggleCancelFlag, sessionScreen, defaultSection) => {
  switch (field.type) {
    case 'studySelector': {
      return (
        <PreferencesCommonStudySelector
          className={field.class}
          field={field}
          updatePreferences={updatePreferences}
          handleWeightTypes={handleWeightTypes}
          autoUpdate={autoUpdate}
          latestStudies={latestStudies}
          modifiedPreferences={modifiedPreferences}
        />
      );
    }
    case 'dropdown': {
      return (
        <PreferencesCustomDropdown
          className={field.class}
          field={field}
          style={field.style}
          updatePreferences={updatePreferences}
        />);
    }
    case 'colorPickerInputBox': {
      return (
        <ColorPickerInputBox
          className={field.class}
          field={field}
          updatePreferences={updatePreferences}
          // userPrefrencesData={modifiedPreferences}
          modifiedPreferences={modifiedPreferences}
        />);
    }
    case 'input': return (<input type="text" className={field.class} placeholder="Search.." />);
    case 'radio': return (
      <PreferencesCustomRadioButtons
        field={field}
        className={field.class}
        updatePreferences={updatePreferences}
        modifiedPreferences={modifiedPreferences}
      />);
    case 'label': return (<div
      style={field.style !== undefined ? field.style : { padding: '10px 0px' }}
    >{field.label}</div>);
    case 'smartSearch': {
      return (
        <PreferencesCommonSmartSearch
          field={field}
          updatePreferences={updatePreferences}
          modifiedPreferences={modifiedPreferences}
          setPreferenceWarning={setPreferenceWarning}
          sessionScreen={sessionScreen}
          defaultSection={defaultSection}
        />
      );
    }
    case 'list': return (
      <PreferencesCommonListMenu
        className={field.class}
        field={field}
        updatePreferences={updatePreferences}
      />
    );
    case 'singlecheckbox': return (
      <PreferencesCustomCheckbox
        className={field.class}
        field={field}
        updatePreferences={updatePreferences}
      />
    );
    case 'autoUpdate': return (
      <PreferencesAutoUpdateCheckbox
        className={field.class}
        field={field}
        cancelAutoUpdateFlag={cancelAutoUpdateFlag}
        toggleCancelFlag={toggleCancelFlag}
        updatePreferences={updatePreferences}
        modifiedPreferences={modifiedPreferences}
      />
    );
    case 'dataInput': return (
      <PreferencesCommonDataInput
        field={field}
        updatePreferences={updatePreferences}
        modifiedPreferences={modifiedPreferences}
        setPreferenceWarning={setPreferenceWarning}
        sessionScreen={sessionScreen}
      />
    );
    case 'filterSlider': return (
      <PreferencesCommonFilterSlider
        field={field}
        updatePreferences={updatePreferences}
        modifiedPreferences={modifiedPreferences}
      />
    );
    case 'inlineEdit': return (
      <PreferencesCommonInlineEdit
        field={field}
        updatePreferences={updatePreferences}
        modifiedPreferences={modifiedPreferences}
        setPreferenceWarning={setPreferenceWarning}
        defaultSection={defaultSection}
      />
    );
    case 'selectDropdown': return (
      <PreferencesCommonDropdown
        field={field}
        updatePreferences={updatePreferences}
        modifiedPreferences={modifiedPreferences}
      />
    );
    case 'rangeFilter': return (
      <PreferencesCommonRangeFilter
        field={field}
        updatePreferences={updatePreferences}
        modifiedPreferences={modifiedPreferences}
      />
    );
    case 'filterSearch': return (
      <PreferencesCommonFilterSearch
        field={field}
        updatePreferences={updatePreferences}
        modifiedPreferences={modifiedPreferences}
      />
    );
    case 'profileAttitudeList': return (
      <PreferencesCommonProfileAttitudeList
        field={field}
        modifiedPreferences={modifiedPreferences}
        updatePreferences={updatePreferences}
      />
    );
    case 'studyFamily': return (
      <PreferencesCommonStudyFamilySelector
        field={field}
        updatePreferences={updatePreferences}
        modifiedPreferences={modifiedPreferences}
      />
    );
    default: return (
      <div />
    );
  }
};

const DynamicInputFinder = ({ field, updatePreferences, handleWeightTypes,
  modifiedPreferences, userPreferences, setPreferenceWarning, autoUpdate,
  latestStudies, cancelAutoUpdateFlag, toggleCancelFlag, sessionScreen, defaultSection }) => {
  // const fieldType = field.field;
  const component = getMatchedInputComponent(field, updatePreferences, handleWeightTypes,
    modifiedPreferences, userPreferences, setPreferenceWarning, autoUpdate, latestStudies,
    cancelAutoUpdateFlag, toggleCancelFlag, sessionScreen, defaultSection);
  return (<div className={field.class}>{component}</div>);
};

DynamicInputFinder.propTypes = {  
  field: PropTypes.shape({
    class: PropTypes.string,    
    style: PropTypes.shape({      
      padding: PropTypes.string,
    }),
  }),
  updatePreferences: PropTypes.func,
  modifiedPreferences: PropTypes.shape({}),
  userPreferences: PropTypes.shape({}),
  handleWeightTypes: PropTypes.shape({}),
  setPreferenceWarning: PropTypes.shape({}),
  insight360Actions: PropTypes.shape({}),
  autoUpdate: PropTypes.shape({}),
  latestStudies: PropTypes.shape({}),
  cancelAutoUpdateFlag: PropTypes.shape({}),
  toggleCancelFlag: PropTypes.shape({}),
  sessionScreen: PropTypes.shape({}),
  defaultSection: PropTypes.shape({}),  
};
export default DynamicInputFinder;
